import { getValue } from "../../../utils/general";

// Same rounding as the displayed value (Math.round(x * 100) / 100 turns
// 2.345 into 2.34); "|| 0" turns -0 into 0, which Intl would print "-0,00".
const TWO_DECIMALS = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
  useGrouping: false,
});

const roundStat = (value) => Number(TWO_DECIMALS.format(value)) || 0;

const formatStat = (value, isCount = false) => {
  const number =
    typeof value === "string" && value.trim() !== "" ? Number(value) : value;
  return !isCount && typeof number === "number" && Number.isFinite(number)
    ? getValue(number)
    : value;
};

export { roundStat, formatStat };
